import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, onUnmounted, Ref } from 'vue';
import { storeToRefs } from 'pinia';
import { Message } from 'element-ui';

import IconButton from '../common/IconButton.vue';
import VideoSettingTab from '../base/VideoSettingTab.vue';
import TUIRoomCore from '../../tui-room-core';

import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import { ICON_NAME } from '../../../constants/icon';
import { WARNING_MESSAGE, MESSAGE_DURATION } from '../../../constants/message';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoControl',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();

const { isDefaultOpenCamera, localStream, isLocalVideoMuted } = storeToRefs(roomStore);
const { isLocalVideoIconDisable, isMuteAllVideo, isAudience } = storeToRefs(basicStore);

const showVideoSettingTab: Ref<boolean> = ref(false);
const videoIconButtonRef = ref<InstanceType<typeof IconButton>>();
const videoSettingRef = ref<InstanceType<typeof VideoSettingTab>>();

const iconName = computed(() => {
  if (isLocalVideoIconDisable.value) {
    return ICON_NAME.CameraOffDisabled;
  }
  return isLocalVideoMuted.value ? ICON_NAME.CameraOff : ICON_NAME.CameraOn;
});

watch(isDefaultOpenCamera, (val) => {
  isLocalVideoMuted.value = !val;
}, { immediate: true });

watch(localStream, (val) => {
  isLocalVideoMuted.value = !val.isVideoStreamAvailable;
}, { immediate: true });

function toggleMuteVideo() {
  if (isLocalVideoIconDisable.value) {
    let warningMessage = '';
    if (isMuteAllVideo.value) {
      warningMessage = WARNING_MESSAGE.UNMUTE_LOCAL_CAMERA_FAIL_MUTE_ALL;
    } else if (isAudience.value) {
      warningMessage = WARNING_MESSAGE.UNMUTE_LOCAL_CAMERA_FAIL_AUDIENCE;
    }
    Message({
      type: 'warning',
      message: warningMessage,
      duration: MESSAGE_DURATION.NORMAL,
    });
    return;
  }

  roomStore.setIsLocalVideoMuted(!isLocalVideoMuted.value);
  // 关闭本地摄像头的时候应该熄灭摄像头灯，使用 stopCameraPreview 方法 
  console.log("------------关闭本地摄像头----roomStore---------------------")
  if (isLocalVideoMuted.value) {
    TUIRoomCore.stopCameraPreview();
  } else {
    const previewDom = document.getElementById(`${roomStore.localStream.userId}_main`);
    previewDom && TUIRoomCore.startCameraPreview(previewDom);
  }
  showVideoSettingTab.value = false;
}

function handleMore() {
  if (!showVideoSettingTab.value) {
    showVideoSettingTab.value = true;
  } else {
    showVideoSettingTab.value = false;
  }
}

function handleDocumentClick(event: MouseEvent) {
  if (
    showVideoSettingTab.value
    && !videoIconButtonRef.value?.$el.contains(event.target)
    && !videoSettingRef.value?.$el.contains(event.target)
  ) {
    showVideoSettingTab.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleDocumentClick, true);
});

onUnmounted(() => {
  document.removeEventListener('click', handleDocumentClick, true);
});


return { __sfc: true,basicStore, roomStore, isDefaultOpenCamera, localStream, isLocalVideoMuted, isLocalVideoIconDisable, isMuteAllVideo, isAudience, showVideoSettingTab, videoIconButtonRef, videoSettingRef, iconName, toggleMuteVideo, handleMore, handleDocumentClick, IconButton, VideoSettingTab }
}

})